import { IBaseAction } from "../Actions/BaseAction";
import { App } from "../Enums/App";
import { AppView } from "../Enums/AppView";

export type SetCurrentAppAction = IBaseAction<App>;
export type SetAppViewAction = IBaseAction<AppView>;
export type SetAppPastIntroAction = IBaseAction<App>;
export type ResetAppPastIntroAction = IBaseAction<App>;
export type ShowHeaderNav = IBaseAction<boolean>;

export type AppActionType =
    SetCurrentAppAction |
    SetAppViewAction |
    SetAppPastIntroAction |
    ShowHeaderNav |
    ResetAppPastIntroAction;

export const SET_CURRENT_APP = "SET_CURRENT_APP";
export const SET_APP_VIEW = "SET_APP_VIEW";
export const SET_APP_PAST_INTRO = "SET_APP_PAST_INTRO";
export const SHOW_HEADER_NAV = "SHOW_HEADER_NAV";
export const RESET_APP_PAST_INTRO = "RESET_APP_PAST_INTRO";
